import { SECTION_HREF_MAP } from '../../../EditDrawer.config';

import { validateTitleCompanySection, validateTitleHolderSection } from './utils';

export const SECTION_VALIDATORS = {
  [SECTION_HREF_MAP.TITLE_COMPANY]: validateTitleCompanySection,
  [SECTION_HREF_MAP.TITLE_HOLDER]: validateTitleHolderSection,
};
